// Source for email regex: https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript
import { FEATURE_TOGGLE } from './FeatureToggle';

export const isEmailValid = (email: string): boolean => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

export const isPasswordStrong = (password: string): boolean => {
  return new RegExp(
    '^(?=.*[A-Za-z])(?=.*\\d)(?=.*[@$!%*#?&])[A-Za-z\\d@$!%*#?&]{12,}$',
  ).test(password);
};

export const isValidEmailDomain = (email: string): boolean => {
  const envDomains: string = FEATURE_TOGGLE.VALID_EMAIL_DOMAINS;
  const domains: string[] = envDomains
    ? envDomains.split(',').map((e) => e.trim())
    : [];

  const [_, userEmailDomain] = email.split('@');

  return Boolean(domains.find((e) => e === `@${userEmailDomain}`));
};

export const isValidNumber = (value: string): boolean => /[0-9]/.test(value);
